export const PLATFORM_BASE_URL = "https://keycloak.okton.com.br/platform-api";
